(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["uh-legal-guarantee"] && !Shopify.designMode) return;
  try {
    (() => {
  let opener;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-uh-guarantee-open]');
    const dialog = document.getElementById('UHGuaranteeDialog');
    if (link && dialog && typeof dialog.showModal === 'function') {
      event.preventDefault();
      opener = link;
      dialog.showModal();
      dialog.scrollTop = 0;
      dialog.querySelector('.uh-guarantee-text').open = window.matchMedia('(max-width:600px)').matches;
    }
    if (event.target.closest('[data-uh-guarantee-close]')) dialog?.close();
    if (event.target === dialog) {
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    }
  });
  document.getElementById('UHGuaranteeDialog')?.addEventListener('close', () => opener?.focus());
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["uh-purchase-clean"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializePurchase = (root) => {
      if (root.dataset.uhReady) return;
      const form = root.querySelector('form');
      const master = root.querySelector('[data-uh-variant-id]');
      const optionFieldset = root.querySelector('[data-uh-variant-options]');
      if (!form || !master || !optionFieldset) return;
      let variants;
      try { variants = JSON.parse(root.querySelector('[data-uh-variant-data]').textContent); }
      catch { return; }
      if (!Array.isArray(variants) || !variants.length) return;
      const options = [...optionFieldset.querySelectorAll('[data-uh-option]')];
      const price = root.querySelector('[data-uh-price]');
      const deliveryPrice = root.querySelector('[data-uh-delivery-price]');
      const europePrice = root.querySelector('[data-uh-europe-price]');
      const availability = root.querySelector('[data-uh-availability]');
      const button = root.querySelector('[data-uh-add]');
      const fallback = root.querySelector('[data-uh-variant-fallback]');
      const update = () => {
        const selected = options.map((option) => option.value);
        const variant = variants.find((candidate) => candidate.options.every((value, index) => value === selected[index]));
        const complete = selected.every(Boolean) && [...form.querySelectorAll('select[name^="properties["]')].every(input => Boolean(input.value));
        const available = Boolean(variant?.available) && complete;
        master.value = variant ? String(variant.id) : '';
        master.disabled = !variant;
        if (price) price.textContent = variant ? variant.price : root.dataset.priceLabel;
        deliveryPrice.textContent = variant ? variant.deliveryPrice : root.dataset.priceLabel;
        if (europePrice) europePrice.textContent = variant ? variant.europePrice : root.dataset.priceLabel;
        availability.textContent = !complete ? root.dataset.selectLabel : variant ? (available ? (variant.preorder ? root.dataset.preorderLabel : root.dataset.availableLabel) : root.dataset.unavailableLabel) : root.dataset.combinationLabel;
        availability.dataset.stockStatus = !complete ? 'neutral' : !available ? 'unavailable' : variant.preorder ? 'preorder' : 'in-stock';
        button.disabled = !available;
        button.textContent = !complete ? root.dataset.selectLabel : available ? root.dataset.addLabel : root.dataset.unavailableLabel;
        root.querySelectorAll('[data-uh-swatch]').forEach(chip => { chip.setAttribute('aria-pressed', String(options[Number(chip.dataset.optionIndex)]?.value === chip.dataset.value)); });
        const battery = root.querySelector('[data-uh-battery-property]');
        if (battery) {
          battery.disabled = !variant;
          battery.value = variant ? (variant.options.some(value => value.includes('25 km/h')) ? 'Blei-Gel 72 V / 100 Ah' : 'LiFePO₄ 72 V / 150 Ah') : '';
          root.querySelector('[data-uh-battery-summary]').textContent = variant ? battery.value : root.dataset.selectLabel;
        }
        const scope = root.closest('[data-uh-product-scope]');
        const productImage = scope?.querySelector('[data-uh-product-image], .uh-model-visual img, .uh-product-media__item--featured img');
        if (productImage && variant?.image) {
          productImage.src = variant.image;
          productImage.removeAttribute('srcset');
          productImage.alt = variant.imageAlt;
        }
        root.dispatchEvent(new CustomEvent('uh:variant-change', {bubbles: true, detail: {variant}}));
        if (variant?.sku && root.dataset.uhModelSku) {
          let sku = variant.sku.replace(/-(STICK|SEAT|CAPTAIN|BOTH)(?:-(STICK|SEAT|CAPTAIN|BOTH))*$/, '');
          if (sku.startsWith('UH-CABIN-MAX-45-') && !sku.includes('-LFP-')) sku = sku.replace('UH-CABIN-MAX-45-', 'UH-CABIN-MAX-45-LFP-');
          root.dataset.selectedSku = sku;
          root.dispatchEvent(new CustomEvent('uh:configuration-change', {bubbles:true, detail:{sku,modelSku:root.dataset.uhModelSku}}));
        }
      };
      options.forEach(option => {
        if (!option.hasAttribute('data-uh-single-value')) option.value = '';
        const isBattery = /batter|akku/.test(option.dataset.uhOptionName || '');
        const values = [...option.options].filter(value => value.value);
        if (isBattery && values.length === 1 && root.querySelector('.uh-purchase-batteries')) {
          option.value = values[0].value;
          option.closest('.uh-purchase-field').hidden = true;
        }
      });
      form.addEventListener('change', update);
      root.querySelectorAll('[data-uh-swatch]').forEach(chip => chip.addEventListener('click', () => {
        options[Number(chip.dataset.optionIndex)].value = chip.dataset.value;
        update();
      }));
      form.addEventListener('submit', (event) => {
        update();
        if (button.disabled) event.preventDefault();
      });
      update();
      options.forEach(option => {
        const field = option.closest('.uh-purchase-field');
        if (!field?.querySelector('[data-uh-swatch]')) return;
        option.hidden = true;
        const label = field.querySelector('label');
        if (label) label.removeAttribute('for');
      });
      optionFieldset.hidden = false;
      optionFieldset.disabled = false;
      fallback.hidden = true;
      master.required = false;
      root.dataset.uhReady = 'true';
    };
    const initializeAll = (scope) => {
      if (scope.matches?.('[data-uh-purchase]')) initializePurchase(scope);
      scope.querySelectorAll('[data-uh-purchase]').forEach(initializePurchase);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(document), {once: true});
    } else {
      initializeAll(document);
    }
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["uh-purchase"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializePurchase = (root) => {
      if (root.dataset.uhReady) return;
      const form = root.querySelector('form');
      const master = root.querySelector('[data-uh-variant-id]');
      const optionFieldset = root.querySelector('[data-uh-variant-options]');
      if (!form || !master || !optionFieldset) return;
      let variants;
      try { variants = JSON.parse(root.querySelector('[data-uh-variant-data]').textContent); }
      catch { return; }
      if (!Array.isArray(variants) || !variants.length) return;
      const options = [...optionFieldset.querySelectorAll('[data-uh-option]')];
      const price = root.querySelector('[data-uh-price]');
      const deliveryPrice = root.querySelector('[data-uh-delivery-price]');
      const europePrice = root.querySelector('[data-uh-europe-price]');
      const availability = root.querySelector('[data-uh-availability]');
      const button = root.querySelector('[data-uh-add]');
      const fallback = root.querySelector('[data-uh-variant-fallback]');
      const update = () => {
        const selected = options.map((option) => option.value);
        const variant = variants.find((candidate) => candidate.options.every((value, index) => value === selected[index]));
        const complete = selected.every(Boolean) && [...form.querySelectorAll('select[name^="properties["]')].every(input => Boolean(input.value));
        const available = Boolean(variant?.available) && complete;
        master.value = variant ? String(variant.id) : '';
        master.disabled = !variant;
        if (price) price.textContent = variant ? variant.price : root.dataset.priceLabel;
        deliveryPrice.textContent = variant ? variant.deliveryPrice : root.dataset.priceLabel;
        if (europePrice) europePrice.textContent = variant ? variant.europePrice : root.dataset.priceLabel;
        availability.textContent = !complete ? root.dataset.selectLabel : variant ? (available ? root.dataset.availableLabel : root.dataset.unavailableLabel) : root.dataset.combinationLabel;
        availability.dataset.available = String(available);
        button.disabled = !available;
        button.textContent = !complete ? root.dataset.selectLabel : available ? root.dataset.addLabel : root.dataset.unavailableLabel;
        root.querySelectorAll('[data-uh-swatch]').forEach(chip => { chip.setAttribute('aria-pressed', String(options[Number(chip.dataset.optionIndex)]?.value === chip.dataset.value)); });
        const battery = root.querySelector('[data-uh-battery-property]');
        if (battery) {
          battery.disabled = !variant;
          battery.value = variant ? (variant.options.some(value => value.includes('25 km/h')) ? 'Blei-Gel 72 V / 100 Ah' : 'LiFePO₄ 72 V / 150 Ah') : '';
          root.querySelector('[data-uh-battery-summary]').textContent = variant ? battery.value : root.dataset.selectLabel;
        }
        const scope = root.closest('[data-uh-product-scope]');
        const productImage = scope?.querySelector('[data-uh-product-image], .uh-model-visual img, .uh-product-media__item--featured img');
        if (productImage && variant?.image) {
          productImage.src = variant.image;
          productImage.removeAttribute('srcset');
          productImage.alt = variant.imageAlt;
        }
        root.dispatchEvent(new CustomEvent('uh:variant-change', {bubbles: true, detail: {variant}}));
        if (variant?.sku && root.dataset.uhModelSku) {
          let sku = variant.sku.replace(/-(STICK|SEAT|CAPTAIN|BOTH)(?:-(STICK|SEAT|CAPTAIN|BOTH))*$/, '');
          if (sku.startsWith('UH-CABIN-MAX-45-') && !sku.includes('-LFP-')) sku = sku.replace('UH-CABIN-MAX-45-', 'UH-CABIN-MAX-45-LFP-');
          root.dataset.selectedSku = sku;
          root.dispatchEvent(new CustomEvent('uh:configuration-change', {bubbles:true, detail:{sku,modelSku:root.dataset.uhModelSku}}));
        }
      };
      options.forEach(option => { option.value = ''; });
      form.addEventListener('change', update);
      root.querySelectorAll('[data-uh-swatch]').forEach(chip => chip.addEventListener('click', () => {
        options[Number(chip.dataset.optionIndex)].value = chip.dataset.value;
        update();
      }));
      form.addEventListener('submit', (event) => {
        update();
        if (button.disabled) event.preventDefault();
      });
      update();
      optionFieldset.hidden = false;
      optionFieldset.disabled = false;
      fallback.hidden = true;
      master.required = false;
      root.dataset.uhReady = 'true';
    };
    const initializeAll = (scope) => {
      if (scope.matches?.('[data-uh-purchase]')) initializePurchase(scope);
      scope.querySelectorAll('[data-uh-purchase]').forEach(initializePurchase);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(document), {once: true});
    } else {
      initializeAll(document);
    }
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
